"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformationLinkStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const Information_1 = require("../Information/Information");
exports.InformationLinkStyled = styled(Information_1.Information) `
&.octo {
  >.info {
    >.content {
      > a {
        color: ${design_system_1.theme.colors.marine[100]};
      }

      >.outdated {
        margin-top: 0.5em;

        > b {
          font-weight: 600;
        }
      }
    }
  }

  &.active {
    >.icon {
      color: ${design_system_1.theme.colors.green[100]};
      mask-size: 3em;
    }
  }

  &.inactive {
    >.icon {
      color: ${design_system_1.theme.colors.red[100]};
      mask-size: 3em;
    }
  }

  &.outdated {
    >.icon {
      color: ${design_system_1.theme.colors.orange[100]};
      mask-size: 3em;
    }
  }
}
`;
//# sourceMappingURL=InformationLink.styled.js.map